import type { ReactNode } from 'react';
import { Badge } from '@mui/material';

export interface ActionBadgeProps {
  badgeContent: number;
  bgcolor?: string;
  color?: string;
  children: ReactNode;
}

const ActionBadge = ({
  badgeContent,
  bgcolor = 'primary.main',
  color = 'primary.contrastText',
  children,
}: ActionBadgeProps) => (
  <Badge
    badgeContent={badgeContent}
    invisible={badgeContent === 0}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    sx={{
      '& .MuiBadge-badge': {
        top: 6,
        right: 6,
        bgcolor,
        color,
      },
    }}
  >
    {children}
  </Badge>
);

export default ActionBadge;
